import { useCallback, useRef, useState } from 'react';

import { Button } from '@components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@components/ui/dropdown-menu';
import { useDimensions } from '@hooks/useDimensions';
import { FilePen, FolderPlus } from 'lucide-react';
import { Link, useParams } from 'react-router';

import CreateFolderDialog, {
  type IRefProps as CreateFolderRef,
} from './CreateFolderDialog';

function HeaderButton() {
  const params = useParams();
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const createFolderDialogRef = useRef<CreateFolderRef>(null);
  const { width } = useDimensions();

  const handleOpenCreateFolderDialog = useCallback(() => {
    createFolderDialogRef.current?.open();
  }, []);

  return (
    <div className="flex w-full justify-end">
      <DropdownMenu onOpenChange={setMenuIsOpen} open={menuIsOpen}>
        <DropdownMenuTrigger asChild className="mb-4">
          <Button
            className="w-full max-w-44 cursor-pointer"
            size={width < 640 ? 'sm' : 'default'}
            variant="secondary">
            ADICIONAR
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-56">
          <DropdownMenuGroup>
            <DropdownMenuItem
              asChild
              className="focus:bg-tertiary [&>svg]:size-6">
              <Link to={`/anotacoes${params.id ? `/${params.id}` : ''}/nova`}>
                <FilePen className="size-6" strokeWidth={1.5} />
                Adicionar anotação
              </Link>
            </DropdownMenuItem>

            <DropdownMenuItem
              className="focus:bg-tertiary [&>svg]:size-6"
              onClick={(e) => {
                e.stopPropagation();
                setMenuIsOpen(false);
                handleOpenCreateFolderDialog();
              }}
              onSelect={(e) => e.preventDefault()}>
              <FolderPlus className="size-6" strokeWidth={1.5} />
              Adicionar pasta
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>

      <CreateFolderDialog ref={createFolderDialogRef} />
    </div>
  );
}

export default HeaderButton;
